import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { Constant } from "../../constant";
import { ShortcutService } from "../../service/shortcut.service";
import { Subscription, of } from 'rxjs';
import { EventManagerService } from '../../service/event-manager.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateUtil } from 'src/app/common/utils/date.util';
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
    selector: 'no-connect-internet-popup',
    templateUrl: "./no-connect-internet-popup.html",
    styleUrls: ["./no-connect-internet-popup.scss"]
})

export class NoConnectInternetComponent implements OnInit, OnDestroy {
    public Constant = Constant;
    @Output() result: EventEmitter<any> = new EventEmitter();
    @Input() title: any;
    @Input() message: any;
    @Input() isOkButton: any;
    @Input() iconImage: any = Constant.logo_no_connect_internet;
    @Input() isDismissAll: boolean;
    public subscriptions?: Subscription[] = [];
    constructor(
        public eventManger: EventManagerService,
        public activeModal: NgbActiveModal,
        public ngModal: NgbModal
    ) {}
    ngOnInit() {
        this.subscriptions  = [
            this.eventManger.subscribe('close-popup-no-internet', (res) => {
                this.dismiss();
            })
        ]
    }
    ngOnDestroy() {
        this.eventManger.destroys(this.subscriptions);
      }
    dismiss() {
        ShortcutService.removeFuncEsc();
        if (!this.isDismissAll) {
            this.activeModal.dismiss();
        } else {
            this.ngModal.dismissAll();
        }
        this.result.emit(true);
    }
}
